import React from 'react';
import OldArchitectureBlock from './OldArchitectureBlock';
import { BMC_BLOCKS } from '../common_components/bmc/bmc_constants';
import { LEAN_BLOCKS } from './constants';
import { Layer, Rect, Stage, Group, Text, Arrow } from 'react-konva';
import { injectIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';

function OldActivityArchitecture({ history }) {
  const blocks = [
    BMC_BLOCKS.KEY_ACTIVITIES,
    BMC_BLOCKS.REVENUE_STREAMS,
    BMC_BLOCKS.CUSTOMER_SEGMENTS,
    BMC_BLOCKS.KEY_PROPOSITIONS,
    BMC_BLOCKS.CUSTOMER_RELATIONSHIPS,
    BMC_BLOCKS.CHANNELS,
    BMC_BLOCKS.KEY_RESOURCES,
    BMC_BLOCKS.KEY_PARTNERS,
    BMC_BLOCKS.COST_STRUCTURE
  ];

  const width = 720;
  const height = 800;

  return (
    <div className="architecture-block-container">
      <Stage width={width} height={height}>
        <Layer>
          <KeyActivityGraphic width={710} history={history} />
        </Layer>
      </Stage>
    </div>
  );
}

@injectIntl
@inject('rootStore')
@observer
class KeyActivityGraphic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardDescriptionHeight: 0
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.history.push(
      this.props.rootStore.blockPath(BMC_BLOCKS.KEY_ACTIVITIES)
    );
  }

  getArrowColor(val) {
    if (val > 0) {
      return '#7BA3D3';
    }
    return '#ddd';
  }

  render() {
    const { intl, width } = this.props;
    const margin = 5;
    const fullWidth = width;
    const arrowLength = 20;
    const arrowStrokeWidth = 10;
    const smallWidth = 160;
    const mediumWidth = ((smallWidth + arrowLength) * 2 + arrowLength) / 2;
    const halfWidth = (fullWidth - arrowLength) / 2;
    const thirdWidth = (fullWidth - 2 * arrowLength) / 3;
    const smallHeight = 110;
    const mediumHeight = 250;
    const activityHeaderHeight = 80;

    const revenuesPosition = { x: margin, y: margin };
    const measurePosition = { x: margin + halfWidth + arrowLength, y: margin };
    const activityPosition = {
      x: margin,
      y: measurePosition.y + smallHeight + arrowLength
    };
    const propositionPosition = {
      x: 2 * margin,
      y:
        activityPosition.y +
        activityHeaderHeight +
        this.state.cardDescriptionHeight +
        2 * margin
    };
    const relationsPosition = {
      x: propositionPosition.x + smallWidth + arrowLength,
      y: propositionPosition.y
    };
    const channelsPosition = {
      x: relationsPosition.x + smallWidth + arrowLength,
      y: propositionPosition.y
    };
    const customersPosition = {
      x: channelsPosition.x + smallWidth + arrowLength,
      y: propositionPosition.y
    };
    const buildPosition = {
      x: propositionPosition.x + smallWidth + arrowLength,
      y: propositionPosition.y + mediumHeight + arrowLength
    };
    const learnPosition = {
      x: buildPosition.x + smallWidth + arrowLength,
      y: buildPosition.y
    };
    const resourcesPosition = { x: margin, y: 645 + arrowLength };
    const partnersPosition = {
      x: resourcesPosition.x + thirdWidth + arrowLength,
      y: resourcesPosition.y
    };
    const costsPosition = {
      x: partnersPosition.x + thirdWidth + arrowLength,
      y: resourcesPosition.y
    };

    // ARROW POSITIONS
    const revenuesArrowPosition = {
      x: revenuesPosition.x + halfWidth,
      y: revenuesPosition.y + smallHeight / 2
    };
    const measureArrowPosition = {
      x: measurePosition.x + halfWidth / 2,
      y: measurePosition.y + smallHeight
    };
    const propositionRelationArrowPosition = {
      x: propositionPosition.x + smallWidth,
      y: propositionPosition.y + mediumHeight / 2
    };
    const relationsArrowPosition = {
      x: relationsPosition.x + smallWidth,
      y: relationsPosition.y + mediumHeight / 2
    };
    const channelsArrowPosition = {
      x: channelsPosition.x + smallWidth,
      y: channelsPosition.y + mediumHeight / 2
    };
    const customersLearnArrowPosition = {
      x: customersPosition.x + smallWidth / 2,
      y: customersPosition.y + mediumHeight
    };
    const buildArrowPosition = {
      x: buildPosition.x,
      y: buildPosition.y + smallHeight / 2
    };
    const learnArrowPosition = {
      x: learnPosition.x,
      y: learnPosition.y + smallHeight / 2
    };
    const resourcesArrowPosition = {
      x: resourcesPosition.x + thirdWidth / 2,
      y: resourcesPosition.y
    };
    const partnersArrowPosition = {
      x: partnersPosition.x + thirdWidth / 2,
      y: partnersPosition.y
    };
    const costsArrowPosition = {
      x: costsPosition.x + thirdWidth / 2,
      y: costsPosition.y
    };

    const channelsArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.getSelectedCardsCountByBlock(
        BMC_BLOCKS.CHANNELS
      )
    );
    const customerRelArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.getSelectedCardsCountByBlock(
        BMC_BLOCKS.CUSTOMER_RELATIONSHIPS
      )
    );
    const revenuesArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.getSelectedCardsCountByBlock(
        BMC_BLOCKS.REVENUE_STREAMS
      )
    );
    const resourcesArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.getSelectedCardsCountByBlock(
        BMC_BLOCKS.KEY_RESOURCES
      )
    );
    const partnersArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.getSelectedCardsCountByBlock(
        BMC_BLOCKS.KEY_PARTNERS
      )
    );
    const costArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.getSelectedCardsCountByBlock(
        BMC_BLOCKS.COST_STRUCTURE
      )
    );
    let learnArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.learn.length
    );
    let buildArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.build.length
    );
    const measureArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.measure.length
    );
    const propositionRelationArrowColor = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.getSelectedCardsCountByBlock(
        BMC_BLOCKS.KEY_PROPOSITIONS
      )
    );
    let customersLearnArrow = this.getArrowColor(
      this.props.rootStore.activityStore.activityEdit.getSelectedCardsCountByBlock(
        BMC_BLOCKS.CUSTOMER_SEGMENTS
      )
    );

    // If is not editing, color learn and build related arrows wit a lighter tone
    if (this.props.rootStore.disableLearnBuildBlocks) {
      learnArrowColor = '#efefef';
      buildArrowColor = '#efefef';
      customersLearnArrow = '#efefef';
    }

    return (
      <Group>
        {this.renderActivity(activityPosition)}
        <Arrow
          x={revenuesArrowPosition.x}
          y={revenuesArrowPosition.y}
          points={[0, 0, arrowLength - arrowStrokeWidth, 0]}
          pointerLength={1}
          pointerWidth={1}
          stroke={revenuesArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={measureArrowPosition.x}
          y={measureArrowPosition.y}
          points={[0, 0, 0, arrowLength - arrowStrokeWidth]}
          pointerLength={1}
          pointerWidth={1}
          stroke={measureArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={propositionRelationArrowPosition.x}
          y={propositionRelationArrowPosition.y}
          points={[0, 0, arrowLength - arrowStrokeWidth, 0]}
          pointerLength={1}
          pointerWidth={1}
          stroke={propositionRelationArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={relationsArrowPosition.x}
          y={relationsArrowPosition.y}
          points={[0, 0, arrowLength - arrowStrokeWidth, 0]}
          pointerLength={1}
          pointerWidth={1}
          stroke={customerRelArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={channelsArrowPosition.x}
          y={channelsArrowPosition.y}
          points={[0, 0, arrowLength - arrowStrokeWidth, 0]}
          pointerLength={1}
          pointerWidth={1}
          fill={'white'}
          stroke={channelsArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={customersLearnArrowPosition.x}
          y={customersLearnArrowPosition.y}
          points={[
            -1,
            0,
            0,
            arrowLength + smallHeight / 2 - margin,
            -margin,
            arrowLength + smallHeight / 2,
            -margin - smallWidth / 2 - arrowLength + 2 * arrowStrokeWidth,
            arrowLength + smallHeight / 2
          ]}
          pointerLength={1}
          pointerWidth={1}
          fill={'white'}
          stroke={customersLearnArrow}
          tension={0.2}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={buildArrowPosition.x}
          y={buildArrowPosition.y}
          points={[
            0,
            1,
            -arrowLength - smallWidth / 2 + margin,
            0,
            -arrowLength - smallWidth / 2,
            -margin,
            -arrowLength - smallWidth / 2,
            -arrowLength - smallHeight / 2 + arrowStrokeWidth
          ]}
          pointerLength={1}
          pointerWidth={1}
          fill={'white'}
          stroke={buildArrowColor}
          tension={0.2}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={learnArrowPosition.x}
          y={learnArrowPosition.y}
          points={[0, 0, -arrowLength + arrowStrokeWidth, 0]}
          pointerLength={1}
          pointerWidth={1}
          fill={'white'}
          stroke={learnArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={resourcesArrowPosition.x}
          y={resourcesArrowPosition.y}
          points={[0, 0, 0, -arrowLength + arrowStrokeWidth]}
          pointerLength={1}
          pointerWidth={1}
          fill={'white'}
          stroke={resourcesArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={partnersArrowPosition.x}
          y={partnersArrowPosition.y}
          points={[0, 0, 0, -arrowLength + arrowStrokeWidth]}
          pointerLength={1}
          pointerWidth={1}
          fill={'white'}
          stroke={partnersArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <Arrow
          x={costsArrowPosition.x}
          y={costsArrowPosition.y}
          points={[0, 0, 0, -arrowLength + arrowStrokeWidth]}
          pointerLength={1}
          pointerWidth={1}
          fill={'white'}
          stroke={costArrowColor}
          strokeWidth={arrowStrokeWidth}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={BMC_BLOCKS.REVENUE_STREAMS}
          x={revenuesPosition.x}
          y={revenuesPosition.y}
          width={(fullWidth - arrowLength) / 2}
          height={smallHeight}
          stepNumber={1}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={LEAN_BLOCKS.MEASURE}
          x={measurePosition.x}
          y={measurePosition.y}
          width={(fullWidth - arrowLength) / 2}
          height={smallHeight}
          stepNumber={2}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={BMC_BLOCKS.CUSTOMER_SEGMENTS}
          x={customersPosition.x}
          y={customersPosition.y}
          width={smallWidth}
          height={mediumHeight}
          stepNumber={7}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={BMC_BLOCKS.CHANNELS}
          x={channelsPosition.x}
          y={channelsPosition.y}
          width={smallWidth}
          height={mediumHeight}
          stepNumber={6}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={BMC_BLOCKS.CUSTOMER_RELATIONSHIPS}
          x={relationsPosition.x}
          y={relationsPosition.y}
          width={smallWidth}
          height={mediumHeight}
          stepNumber={5}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={BMC_BLOCKS.KEY_PROPOSITIONS}
          x={propositionPosition.x}
          y={propositionPosition.y}
          width={smallWidth}
          height={mediumHeight}
          stepNumber={4}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={LEAN_BLOCKS.BUILD}
          x={buildPosition.x}
          y={buildPosition.y}
          width={smallWidth}
          height={smallHeight}
          stepNumber={this.props.rootStore.disableLearnBuildBlocks ? 12 : 9}
          disabled={this.props.rootStore.disableLearnBuildBlocks}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={LEAN_BLOCKS.LEARN}
          x={learnPosition.x}
          y={learnPosition.y}
          width={smallWidth}
          height={smallHeight}
          stepNumber={this.props.rootStore.disableLearnBuildBlocks ? 11 : 8}
          disabled={this.props.rootStore.disableLearnBuildBlocks}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={BMC_BLOCKS.KEY_RESOURCES}
          x={resourcesPosition.x}
          y={resourcesPosition.y}
          width={thirdWidth}
          height={smallHeight}
          stepNumber={this.props.rootStore.disableLearnBuildBlocks ? 8 : 9}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={BMC_BLOCKS.KEY_PARTNERS}
          x={partnersPosition.x}
          y={partnersPosition.y}
          width={thirdWidth}
          height={smallHeight}
          stepNumber={this.props.rootStore.disableLearnBuildBlocks ? 9 : 10}
        />

        <OldArchitectureBlock
          history={this.props.history}
          block={BMC_BLOCKS.COST_STRUCTURE}
          x={costsPosition.x}
          y={costsPosition.y}
          width={thirdWidth}
          height={smallHeight}
          stepNumber={this.props.rootStore.disableLearnBuildBlocks ? 10 : 11}
        />
      </Group>
    );
  }

  componentDidMount() {
    this.setState({
      cardDescriptionHeight: this.refs.description.getHeight()
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const nextCardDescriptionHeight = this.refs.description.getHeight();
    if (this.state.cardDescriptionHeight != nextCardDescriptionHeight) {
      this.setState({
        cardDescriptionHeight: nextCardDescriptionHeight
      });
    }
  }

  renderActivity(activityPosition) {
    const { intl, width } = this.props;
    const block = BMC_BLOCKS.KEY_ACTIVITIES;
    const currentBlock = this.props.rootStore.igBusinessStore.currentBlock;
    const cards = this.props.rootStore.activityStore.activityEdit.getSelectedCardsByBlock(
      block
    );
    let cardDescription = '';
    let cardName = '';
    let fillColor = '#ddd';
    let textColor = '#555';
    if (cards[0]) {
      cardDescription = cards[0].description;
      cardName = cards[0].name || '';
      fillColor = '#6883A4';
      textColor = 'white';
    }
    if (block == currentBlock) {
      fillColor = '#0fa69a';
      textColor = 'white';
    }

    let title =
      '3. ' +
      intl.formatMessage({ id: 'subtitle-key_activities' }).toUpperCase() +
      ' | ' +
      intl.formatMessage({ id: 'IgbmcBoard-' + BMC_BLOCKS.KEY_ACTIVITIES });

    return (
      <Group x={activityPosition.x} y={activityPosition.y}>
        <Group onClick={this.handleClick}>
          <Rect
            x={0}
            y={0}
            width={width}
            height={this.state.cardDescriptionHeight + 50}
            fill={fillColor}
            stroke={fillColor}
            strokeWidth={4}
            cornerRadius={4}
          />
          <Text
            ref={'title'}
            x={10}
            y={10}
            width={width}
            align="left"
            text={title + ': ' + cardName}
            fontSize={14}
            fontFamily="Helvetica"
            fontStyle="bold"
            fill={textColor}
          />

          <Rect
            x={0}
            y={50}
            width={width}
            height={this.state.cardDescriptionHeight + 20}
            fill="white"
            stroke={fillColor}
            strokeWidth={4}
            cornerRadius={4}
          />

          <Text
            ref={'description'}
            x={10}
            y={60}
            width={width}
            align="left"
            text={cardDescription}
            fontSize={16}
            fontFamily="Helvetica"
            fill="#333"
          />
        </Group>

        <Rect
          x={0}
          y={this.state.cardDescriptionHeight + 70}
          width={width}
          height={420}
          fill="white"
          stroke={fillColor}
          strokeWidth={4}
          cornerRadius={4}
        />
      </Group>
    );
  }
}

export default OldActivityArchitecture;
